export default __webpack_public_path__ + "static/media/services-trading.015de4a0.jpg";